import BaseService from '@src/services/BaseService'

class PosFlagsService extends BaseService {
    constructor() {
        super('pos-flags')
    }

    removeAllPos(id, params) {
        this.axios.post(`${this.getUrl()}/${id}/remove-all-pos`, params)
    }
}

export default new PosFlagsService()
